import { Routes, Route, Navigate } from 'react-router-dom';
import AuthenticatePage from './pages/AuthenticatePage/AuthenticatePage';
import HomePage from './pages/HomePage/HomePage';
import ProfilePage from './pages/ProfilePage/ProfilePage';
import AdminPage from './pages/AdminPage/AdminPage';
import MaintenancePage from './pages/MaintenancePage/MaintenancePage';
import RequireAuth from './auth/RequireAuth';
import Footer from './components/Footer/Footer';
import ScrollToTop from './components/ScrollToTop/ScrollToTop';
import './App.css';

/**
 * Public informational sections linked from the footer. They don't have real
 * content yet, so each one renders the maintenance splash as a "coming soon"
 * placeholder until the section is built.
 */
const STUB_PAGES = [
  { path: '/guias', title: 'Guías de montaña' },
  { path: '/seguridad', title: 'Consejos de seguridad' },
  { path: '/preparar-ruta', title: 'Cómo preparar una ruta' },
  { path: '/equipamiento', title: 'Equipamiento' },
  { path: '/meteo', title: 'Meteo y condiciones' },
  { path: '/faq', title: 'Preguntas frecuentes' },
  { path: '/terminos', title: 'Términos y condiciones' },
  { path: '/privacidad', title: 'Política de privacidad' },
];

function App() {
  return (
    <div className="App">
      <ScrollToTop />
      <Routes>
        {/* Public auth entry point (register / login / activate). */}
        <Route path="/authenticate" element={<AuthenticatePage />} />

        {/* Private area — guarded by the auth "middleware". */}
        <Route
          path="/"
          element={
            <RequireAuth>
              <HomePage />
            </RequireAuth>
          }
        />

        {/* Private profile page — reached from the home avatar button. */}
        <Route
          path="/perfil"
          element={
            <RequireAuth>
              <ProfilePage />
            </RequireAuth>
          }
        />

        {/* Admin-only dashboard. RequireAuth gates the session; the page itself
            verifies the ADMIN role and bounces non-admins back to /perfil. */}
        <Route
          path="/admin"
          element={
            <RequireAuth>
              <AdminPage />
            </RequireAuth>
          }
        />

        {/* Public footer sections — placeholders rendering the maintenance
            splash until each one has real content. */}
        {STUB_PAGES.map(({ path, title }) => (
          <Route
            key={path}
            path={path}
            element={
              <MaintenancePage
                badgeLabel="Próximamente"
                title={title}
                signature="Estamos preparando esta sección."
              />
            }
          />
        ))}

        {/* Anything else falls back to the guarded home, which will bounce
            unauthenticated visitors to /authenticate. */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>

      {/* Global footer — shown on every page below the routed content. */}
      <Footer />
    </div>
  );
}

export default App;
